import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'ngs_parent_theme';
const DEFAULT_THEME = 'light';

export function getStoredTheme() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'light' || v === 'dark' ? v : DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

export default function ParentThemeToggle() {
  const [theme, setTheme] = useState(() => getStoredTheme());

  useEffect(() => {
    applyTheme(theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
  }, [theme]);

  const next = theme === 'light' ? 'dark' : 'light';
  const label = theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme';
  const icon = theme === 'light' ? '🌙' : '☀️';

  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      title={label}
      aria-label={label}
      style={{
        background: 'transparent',
        border: '1px solid var(--ngs-card-border)',
        borderRadius: 8,
        width: 36,
        height: 36,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        fontSize: '1.05rem',
        lineHeight: 1,
        color: 'var(--ngs-text-primary)',
        padding: 0,
      }}
    >
      <span aria-hidden="true">{icon}</span>
    </button>
  );
}
